// extracted by mini-css-extract-plugin
export var sliderRange = "_n8-2";
export var sliderRoot = "_n8-0";
export var sliderThumb = "_n8-3";
export var sliderTrack = "_n8-1";